import React from 'react';
import Switch from '../components/admin/switch/index';

export default function ToggleRow({ name, toggle1, toggle2, index }) {
  return (
    <tr key={index}>
      <td className="notif-row">
        {name}
      </td>
      <td>
        {toggle1 && (
          <Switch
            checked={toggle1.checked}
            onToggle={(checked) => toggle1.onChange(toggle1.tag, checked)}
            toggleId={toggle1.toggleId}
          />
        )}
      </td>
      <td>
        {toggle2 && (
          <Switch
            checked={toggle2.checked}
            onToggle={(checked) => toggle2.onChange(toggle2.tag, checked)}
            toggleId={toggle2.toggleId}
          />
        )}
      </td>
    </tr>
  );
}
